export default __webpack_public_path__ + "static/media/neptune.4f987074.jpg";